import { render } from "./errormessages.vue?vue&type=template&id=1ca37bea&scoped=true"
import script from "./errormessages.vue?vue&type=script&lang=js"
export * from "./errormessages.vue?vue&type=script&lang=js"

import "./errormessages.vue?vue&type=style&index=0&id=1ca37bea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca37bea"]])

export default __exports__